import { useMutation } from "react-query";
import { deleteGenre, updateGenre } from "frontend/src/api/genres";
import { queryClient } from "frontend/src/domain/query-client";
import { notify } from "frontend/src/features/notifications";
import { cacheKey } from "./shared";
export var useDeleteGenre = function () {
    var _a = useMutation(deleteGenre, {
        onError: function () {
            notify({
                variant: "error",
                message: "Не удалось удалить жанр.",
            });
        },
        onSuccess: function () {
            notify({
                variant: "success",
                message: "Жанр удалён.",
            });
        },
        onSettled: function () { return queryClient.invalidateQueries(cacheKey); },
    }), mutate = _a.mutate, isLoading = _a.isLoading;
    return {
        do: function (id) { return mutate(id); },
        isLoading: isLoading,
    };
};
export var useUpdateGenre = function () {
    var _a = useMutation(updateGenre, {
        onError: function () {
            notify({
                variant: "error",
                message: "Не удалось сохранить жанр.",
            });
        },
        onSuccess: function () {
            notify({
                variant: "success",
                message: "Жанр сохранён.",
            });
        },
        onSettled: function () { return queryClient.invalidateQueries(cacheKey); },
    }), mutate = _a.mutate, isLoading = _a.isLoading;
    return {
        do: function (payload) { return mutate(payload); },
        isLoading: isLoading,
    };
};
